// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app .preview.popover{min-width:31.5rem;z-index:1040;max-height:none!important}#app .preview.popover .card-footer,#app .preview.popover .card-header{margin:-.5rem -.75rem;padding-top:.5rem;padding-right:.5rem;padding-bottom:.5rem;padding-left:.5rem}#app .preview.popover .card-header{margin-bottom:1rem;font-size:.8rem}", ""]);
// Exports
module.exports = exports;
